/* unplugin-vue-components disabled */import script from "./Live2D.vue?vue&type=script&setup=true&lang=ts"
export * from "./Live2D.vue?vue&type=script&setup=true&lang=ts"

import "./Live2D.vue?vue&type=style&index=0&id=ccdd6242&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccdd6242"]])

export default __exports__